import { Immutable } from "immer";
import React from "react";

import type { UtilityRightSideBarList as Value } from "@reactivated";

import { getLinkUrl } from "../../utils/wagtail";

type IProps = Immutable<{
    value: Value;
}>;

/**
 * sealy's right side-nav-bar list, rendered natively in-tree by PageSkeleton for
 * the full-document UtilityPage, inside the ``.sidekick`` wrapper.
 *
 * Each link's url resolves through ``getLinkUrl`` (mirrors ``LinkValue.get_url``).
 * NOTE the right bar renders a bare ``<a href>{display_name}`` with NO
 * ``title``/``target`` attributes (unlike the left bar).
 */
export const UtilityRightSideBarList = (props: IProps): React.JSX.Element => {
    return (
        <dl>
            <dt>{props.value.title ?? ""}</dt>
            {(props.value.links ?? []).map((link, index) => (
                <dd key={index}>
                    <a href={getLinkUrl(link)}>{link.display_name ?? ""}</a>
                </dd>
            ))}
        </dl>
    );
};
